/* DEMARE Kategorieseite — Modellzeile (teilt LocalStorage mit der PDP) + Sortierung */
(function () {
  'use strict';
  var LS = 'demare:lastModel';
  var root = document.querySelector('[data-plp-model]');
  var sort = document.querySelector('[data-plp-sort]');

  /* Sortierung */
  if (sort) {
    sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }

  if (!root) return;

  var cur = root.querySelector('[data-model-current]');
  var cnt = root.querySelector('[data-model-count]');
  var btn = root.querySelector('[data-model-toggle]');

  /* Aktives Modell aus URL-Filter oder LocalStorage */
  var params = new URLSearchParams(window.location.search);
  var active = null;
  params.forEach(function (v, k) {
    if (!active && k.indexOf('filter.v.option') === 0) active = v;
  });

  var saved = null;
  try { saved = localStorage.getItem(LS); } catch (e) {}

  /* Das Alt-Script demare-model-memory.js benutzt einen eigenen Schluessel.
     Beide synchron halten, sonst widersprechen sich die Vorauswahlen. */
  var LS_OLD = 'demare_preferred_model';
  if (!saved) { try { saved = localStorage.getItem(LS_OLD); } catch (e) {} }

  function remember(model) {
    if (!model) return;
    try {
      localStorage.setItem(LS, model);
      localStorage.setItem(LS_OLD, model);
      localStorage.setItem('demare_preferred_model_ts', String(Date.now()));
    } catch (e) {}
  }

  var lbl = root.querySelector('.plp-model__l');

  if (active) {
    if (cur) cur.textContent = active;
    if (btn) btn.textContent = 'ändern';
    remember(active);
  } else if (saved) {
    /* Ehrlich beschriften: das ist ein Gedaechtnis, keine Geraeteerkennung. */
    if (lbl) lbl.textContent = 'Zuletzt gewählt';
    if (cur) cur.textContent = saved + ' — noch nicht gefiltert';
    if (btn) btn.textContent = 'Modell wählen';
  }

  /* ---------- Modell-Sheet ----------
     Die Chip-Zeile zeigt nur 6 Modelle. Ohne diesen Waehler ist jedes andere
     Modell unerreichbar und "ändern" waere ein toter Button. */
  var sheet  = document.querySelector('[data-model-sheet]');
  var search = sheet && sheet.querySelector('[data-model-search]');
  var list   = sheet && sheet.querySelector('[data-model-list]');
  var none   = sheet && sheet.querySelector('[data-model-none]');
  var items  = list ? [].slice.call(list.querySelectorAll('[data-model-name]')) : [];
  var lastFocus = null;

  function applyFilter(q) {
    var needle = (q || '').trim().toLowerCase().replace(/\s+/g, ' ');
    var hits = 0;
    items.forEach(function (a) {
      var name = (a.getAttribute('data-model-name') || '').toLowerCase();
      var show = !needle || name.replace(/\s+/g, ' ').indexOf(needle) !== -1;
      a.hidden = !show;
      if (show) hits++;
    });
    if (none) none.hidden = hits > 0;
  }

  function openSheet() {
    if (!sheet) return;
    lastFocus = document.activeElement;
    sheet.hidden = false;
    document.body.classList.add('plp-sheet-open');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    /* Gemerktes Modell vorfiltern: dann ist es ein Tap statt Scrollen. */
    if (search) {
      search.value = (!active && saved) ? saved : '';
      applyFilter(search.value);
      try { search.focus({ preventScroll: true }); } catch (e) { search.focus(); }
      search.select && search.select();
    }
  }

  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    document.body.classList.remove('plp-sheet-open');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  if (sheet && btn) {
    btn.addEventListener('click', openSheet);

    sheet.querySelectorAll('[data-model-close]').forEach(function (el) {
      el.addEventListener('click', closeSheet);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSheet();
    });

    if (search) {
      search.addEventListener('input', function () { applyFilter(search.value); });
      /* Enter auf genau einen Treffer = direkt hin */
      search.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        var vis = items.filter(function (a) { return !a.hidden; });
        if (vis.length === 1) { e.preventDefault(); vis[0].click(); }
      });
    }

    /* Gewaehltes Modell merken, damit PDP und Konfigurator es kennen */
    items.forEach(function (a) {
      a.addEventListener('click', function () {
        if (a.classList.contains('is-active')) return;
        remember(a.getAttribute('data-model-name') || '');
      });
    });
  } else if (btn) {
    /* Fallback ohne Sheet: wenigstens zu den Filtern springen */
    btn.addEventListener('click', function () {
      var f = document.querySelector('.plp-filters');
      if (f) f.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
})();
